import FinalOffer from "./components/FinalOfferPage/index.jsx"
import KFSReviewPage from "./components/KFSReviewPage/loanReview2.js"
import KYCSuccessPage from "./components/KYC Success"
import LiveKYCPage from "./components/LiveKyc"
import LoanApprovedScreen from "./components/LoanApproved/index.jsx"
import RedirectingPage from "./components/RedirectionPage"
import UploadSuccessScreen from "./components/UploadSuccess/index.jsx"
import VerifyBankDetails from "./components/VerifyBankDetails.jsx"



const LendenClubLandingPage = () =>{

    return(
        <div className="w-full max-w-[400px] mx-auto">
            {/* <LiveKYCPage/> */}
            {/* <KYCSuccessPage/> */}
            {/* <RedirectingPage/> */}
            {/* <VerifyBankDetails/> */}
            {/* <LoanApprovedScreen/> */}
             {/* <UploadSuccessScreen/> */}
             {/* <FinalOffer/> */}
             <KFSReviewPage/>

        </div>
    )
}

export default LendenClubLandingPage